package es.cragma.fichajefacil.data

actual fun platformSaveSessionEmail(email: String) {
    js("localStorage.setItem('saved_session_email', email)")
}

actual fun platformGetSessionEmail(): String? {
    return js("localStorage.getItem('saved_session_email')") as? String
}

actual fun platformClearSessionEmail() {
    js("localStorage.removeItem('saved_session_email')")
}
